import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import AdditonalTermsList from '@components/obsolete/additionalterms/AdditonalTermsList.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {
}

const AdditionalTermsListPage: React.FC<ComponentProps> = () => {
  return (
    <ResponsiveLayout>
      <AdditonalTermsList />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(AdditionalTermsListPage);
